export const API_URL = import.meta.env.VITE_SSO_API_URL ?? "";
export const NODE_ENV = process.env.NODE_ENV;
